import { render, staticRenderFns } from "./lista-de-consultas.vue?vue&type=template&id=2579287f&"
import script from "./lista-de-consultas.vue?vue&type=script&lang=ts&"
export * from "./lista-de-consultas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports